import { tv, type VariantProps } from 'tailwind-variants';

export const hintVariants = tv({
	base: 'text-muted-foreground',
	variants: {
		size: {
			xs: 'text-xs',
			sm: 'text-sm'
		}
	},
	defaultVariants: {
		size: 'xs'
	}
});

export type HintVariants = VariantProps<typeof hintVariants>;
